export class FolderPropertyCodes {
    static readonly VIEW_ID = 'viewId';
    static readonly BOX_ID = 'boxId';
    static readonly CREATION_DATE = 'creationDate';
    static readonly UPDATE_DATE = 'updateDate';
    static readonly ID = 'id';
    static readonly NAME = 'name';
}
